import React from "react"
import Terms from "views/pages/settings/terms/terms"

function MerchantTerms({
    merchantId,
    placeId
}) {
    return (
        <Terms merchantId={merchantId} placeId={placeId} />
    )
}

export default MerchantTerms